<template>
  <div class="stc-compact-product-skeleton">
    <div class="stc-compact-product-skeleton__image-container">
      <Skeleton width="100%" height="100%" border-radius="4px" />
    </div>

    <div class="stc-compact-product-skeleton__details">
      <!-- Title -->
      <div class="stc-compact-product-skeleton__title">
        <Skeleton width="100%" height="16px" border-radius="4px" class="margin-bottom-xxs" />
        <Skeleton width="70%" height="16px" border-radius="4px" />
      </div>

      <!-- Price -->
      <Skeleton width="60px" height="20px" border-radius="4px" />

      <!-- Swatches -->
      <div class="stc-compact-product-skeleton__swatches">
        <Skeleton width="21px" height="21px" :border-radius="swatchRadius" />
        <Skeleton width="16px" height="16px" :border-radius="swatchRadius" />
        <Skeleton width="16px" height="16px" :border-radius="swatchRadius" />
        <Skeleton width="16px" height="16px" :border-radius="swatchRadius" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Skeleton from '@atomic-ui/skeleton/Skeleton';
import { useBrand } from '~/composables/useBrand';

const { isMcom } = useBrand();
const swatchRadius = computed(() => (isMcom ? '100%' : '0'));
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.stc-compact-product-skeleton {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
}

.stc-compact-product-skeleton__image-container {
  flex: 0 0 96px;
  width: 96px;
  min-width: 96px;
  max-width: 130px;
  height: 120px;
}

.stc-compact-product-skeleton__details {
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.stc-compact-product-skeleton__title {
  width: 100%;
  margin-bottom: 4px;
}

.stc-compact-product-skeleton__swatches {
  display: flex;
  align-items: center;
  gap: 8px;
}

.margin-bottom-xxs {
  margin-bottom: 4px;
}
</style>
